import { render } from "./FAQ.vue?vue&type=template&id=03ca5f77"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=03ca5f77&lang=scss"
script.render = render

export default script